import { tv } from "tailwind-variants";

export const base =
  "flex px-4 rounded-4 items-center w-66 outline-hidden bg-white hover:bg-grey-2 focus:bg-grey-2 leading-8 transition-colors my-1 cursor-pointer";

export const styles = tv({
  base,
  variants: {
    size: {
      base: "h-12",
      lg: "h-16",
    },
  },
  defaultVariants: {
    size: "base",
  },
});
